export default __webpack_public_path__ + "static/media/Glow.2052f1d3.svg";